import { Button, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap'
import { useAddShortDescriptionMutation } from '../../backoffice/apis/descriptionsAPI'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next';
import { Product } from '../../backoffice/dtos/products/product';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useGetBrandsQuery } from '../../backoffice/apis/brandsAPI';
import IdItemSelection from '../views/common/IdItemSelection';
import { SelectOption } from '../../helpers/SelectOption';
import { confirmAlert } from 'react-confirm-alert';
import { Loading } from '../views/Loading';
import { ErrorComponent } from '../views/ErrorComponent';



export default function ProductEditModal(
    {
        isOpen,
        toggle,
        selectedProduct,
    }:{
        isOpen: boolean;
        toggle: () => void;
        selectedProduct: Product | undefined;
    }
) {
    const [ product, setProduct ] = useState<Product>(selectedProduct ?? { code: "", description: "", shortDescription: "" });
    const [ addShortDescription ] = useAddShortDescriptionMutation()

    const { t } = useTranslation([ 'products', 'common' ])

    const handleUpdate = useCallback(
        async () => {
            try {
                await addShortDescription(product).unwrap()
                toast(t('successful_update_alert'))
                toggle()
            } catch (e:any) {
                toast(e.data.message)
            }
        },
        [product]
    )

    const confirmUpdate = useCallback(() => {
        confirmAlert({
          title: t("Update product details"),
          message: t("Are you sure you want to update the product's details?"),
          buttons: [{ label: t('yes',{ns:'common'}), onClick: handleUpdate }, { label: t('no',{ns:'common'}) }]
        })
    }, [handleUpdate] );

    useEffect(() => {
        setProduct(selectedProduct ?? { code: "", description: "", shortDescription: "", brand: undefined })
    }, [selectedProduct])

    return (
        <div>
            <Modal isOpen={isOpen} toggle={toggle}>
                <ModalHeader toggle={toggle}>{t('edit', { ns: 'common' })}</ModalHeader>
                <ModalBody className='p-3'>
                    {
                        selectedProduct !== undefined || null ?
                            <>
                                <Label>{t('code')}</Label>
                                <Input placeholder={product? product.code : undefined}  disabled={selectedProduct !== undefined}/>
                                <div style={{ height: 10 }} />
                                <Label>{t('description')}</Label>
                                <Input placeholder={product.description} disabled={selectedProduct !== undefined}/>
                                <div style={{ height: 10 }} />
                                <Label>{t('short_description')}</Label>
                                <Input type="text"
                                    placeholder={product.shortDescription}
                                    onChange={(e) => setProduct(ref => ({ ...ref, shortDescription: e.target.value }))}
                                />
                            </>
                            : <Spinner></Spinner>
                    }
                </ModalBody>

                <ModalFooter>
                    <Button color="success" onClick={confirmUpdate}>
                        {t('update',{ns:'common'})}
                    </Button>{' '}
                    <Button color="danger" onClick={toggle}>
                        {t('cancel',{ns:'common'})}
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}
